"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Icon_1 = __importDefault(require("../Icon"));
var Link_1 = __importDefault(require("../Link"));
var SocialIcon_1 = __importDefault(require("./SocialIcon"));
var RegionSelector_1 = __importDefault(require("./RegionSelector"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var LinkSection_1 = __importDefault(require("./LinkSection"));
var Box_1 = __importDefault(require("../Box"));
var Copyright_1 = __importDefault(require("./Copyright"));
var AppDownload_1 = __importDefault(require("./AppDownload"));
var SubscribeForm_1 = __importDefault(require("./SubscribeForm"));
var cookiesUtils_1 = require("../utils/cookiesUtils");
var Grid = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: "grid",
            gridTemplateColumns: '1fr 1fr',
            gridTemplateRows: 'repeat(6, auto)',
            backgroundColor: '#4C4D50',
            padding: theme.space[4],
            color: theme.colors.contrastText,
            fontWeight: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal'
        },
        _b[theme.mediaQueries.sm] = {
            gridTemplateColumns: '1fr 1fr 1fr',
        },
        _b[theme.mediaQueries.md] = {
            gridTemplateColumns: '0.5fr 2fr 2fr 180px 180px',
        },
        _b[theme.mediaQueries.lg] = {
            gridTemplateColumns: '1fr 2fr 2fr 260px 260px',
        },
        _b);
});
Grid.defaultProps = { as: 'footer' };
var LogoCell = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'none'
        },
        _b[theme.mediaQueries.md] = {
            display: 'block',
            gridRow: 1,
            gridColumn: 1,
            justifySelf: 'start',
            paddingLeft: 0,
        },
        _b);
});
var LeftLinkCell = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            gridRow: 2,
            gridColumn: 1,
            justifySelf: 'center',
            width: 'fit-content'
        },
        _b[theme.mediaQueries.sm] = {
            gridRow: 1,
            gridColumn: 1,
        },
        _b[theme.mediaQueries.md] = {
            gridRow: 1,
            gridColumn: 2,
            justifySelf: 'stretch',
            width: '100%'
        },
        _b);
});
var RightLinkCell = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            gridRow: 2,
            gridColumn: 2
        },
        _b[theme.mediaQueries.sm] = {
            gridRow: 1,
            gridColumn: 2,
        },
        _b[theme.mediaQueries.md] = {
            gridRow: 1,
            gridColumn: 3,
        },
        _b);
});
var SpacerBox = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            height: 32,
            marginBottom: theme.space[5]
        },
        _b[theme.mediaQueries.md] = {
            display: 'none'
        },
        _b);
});
var AppCell = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            gridRow: 3,
            gridColumn: '1/-1',
            justifySelf: 'center',
            alignSelf: 'center',
            marginTop: theme.space[4],
            width: '80%'
        },
        _b[theme.mediaQueries.sm] = {
            gridRow: 1,
            gridColumn: 3,
            marginTop: 0,
            width: '100%'
        },
        _b[theme.mediaQueries.md] = {
            gridRow: 1,
            gridColumn: '4 / span 2',
            justifySelf: 'start',
            alignSelf: 'start',
        },
        _b);
});
var FlagCell = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            gridRow: 4,
            gridColumn: '1/-1',
            justifySelf: 'center',
            alignSelf: 'center'
        },
        _b[theme.mediaQueries.md] = {
            gridRow: 2,
            gridColumn: 5,
            justifySelf: 'end',
            alignSelf: 'end',
        },
        _b);
});
var SocialCell = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            gridRow: 5,
            gridColumn: '1/-1',
            justifySelf: 'center',
            alignSelf: 'center',
            marginTop: theme.space[4]
        },
        _b[theme.mediaQueries.md] = {
            gridRow: 2,
        },
        _b[theme.mediaQueries.lg] = {
            gridRow: 3,
            gridColumn: 5,
            justifySelf: 'end',
        },
        _b);
});
var LegalCell = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            gridRow: 6,
            gridColumn: '1/-1',
            justifySelf: 'center',
            alignSelf: 'center',
            marginTop: theme.space[4]
        },
        _b[theme.mediaQueries.lg] = {
            gridRow: 3,
            gridColumn: '1/-1',
            justifySelf: 'start',
            alignSelf: 'end'
        },
        _b);
});
var Footer = function (props) {
    var _a, _b, _c, _d;
    var _e = props || {}, regions = _e.regions, availableRegions = _e.availableRegions, items = _e.items, socialLinks = _e.socialLinks, copyright = _e.copyright, footerRegion = _e.footerRegion, download = _e.download, subscribeForm = _e.subscribeForm, _f = _e.hideRegions, hideRegions = _f === void 0 ? false : _f;
    var icon = (react_1.default.createElement(Link_1.default, { href: "/" },
        react_1.default.createElement(Icon_1.default, { name: "ff-icon-logo", color: "white", fontSize: 5 })));
    var isSubscribed = (0, cookiesUtils_1.isSubscribedToNewsletter)();
    return (react_1.default.createElement("div", null,
        ((subscribeForm === null || subscribeForm === void 0 ? void 0 : subscribeForm.enabled) && !isSubscribed) && react_1.default.createElement(SubscribeForm_1.default, __assign({ footerRegion: footerRegion }, subscribeForm)),
        react_1.default.createElement(Grid, null,
            react_1.default.createElement(LogoCell, null, icon),
            react_1.default.createElement(LeftLinkCell, null,
                react_1.default.createElement(SpacerBox, null, icon),
                react_1.default.createElement(LinkSection_1.default, { sectionTitle: (_a = items === null || items === void 0 ? void 0 : items[0]) === null || _a === void 0 ? void 0 : _a.sectionTitle, links: (_b = items === null || items === void 0 ? void 0 : items[0]) === null || _b === void 0 ? void 0 : _b.links })),
            react_1.default.createElement(RightLinkCell, null,
                react_1.default.createElement(SpacerBox, null),
                react_1.default.createElement(LinkSection_1.default, { sectionTitle: (_c = items === null || items === void 0 ? void 0 : items[1]) === null || _c === void 0 ? void 0 : _c.sectionTitle, links: (_d = items === null || items === void 0 ? void 0 : items[1]) === null || _d === void 0 ? void 0 : _d.links })),
            react_1.default.createElement(AppCell, null,
                react_1.default.createElement(AppDownload_1.default, __assign({ footerRegion: footerRegion }, download))),
            !hideRegions && (react_1.default.createElement(FlagCell, null,
                react_1.default.createElement(RegionSelector_1.default, { regions: regions, footerRegion: footerRegion, availableRegions: availableRegions }))),
            react_1.default.createElement(SocialCell, null,
                react_1.default.createElement(SocialIcon_1.default, { socialLinks: socialLinks })),
            react_1.default.createElement(LegalCell, null,
                react_1.default.createElement(Copyright_1.default, { copyright: copyright })))));
};
Footer.defaultProps = defaultProps_1.default;
exports.default = Footer;
